import type { Resource } from '../../';
export const country_countries_MK: Resource = {"default":"North Macedonia"};
